var _line, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBar02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 860,
    height: 63,
    viewBox: "0 0 860 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 28.5,
    x2: 860,
    y2: 28.5,
    stroke: "#AAAAAA",
    strokeWidth: 9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117,
    cy: 25,
    r: 25,
    fill: "#AAAAAA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 33,
    r: 30,
    fill: "#00FF38"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 743,
    cy: 25,
    r: 25,
    fill: "#AAAAAA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar02);
export default __webpack_public_path__ + "static/media/bar02.112b82484f0e2654989393ccb5526940.svg";
export { ForwardRef as ReactComponent };